/* tslint:disable */
/* eslint-disable */
/**
 * PokerWise Game Management
 * API for managing PokerWise games.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base';
/**
 * GameControllerApi - axios parameter creator
 * @export
 */
export var GameControllerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get a list of all games with pagination.
         * @param {number} [limit] The maximum number of games to return.
         * @param {string} [lastKey] The pagination token to continue fetching results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesGet: function (limit_1, lastKey_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, lastKey_1], args_1, true), void 0, function (limit, lastKey, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/games";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication poker-wise-default-authorizer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Cookie", configuration)];
                        case 1:
                            // authentication poker-wise-default-authorizer required
                            _a.sent();
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (lastKey !== undefined) {
                                localVarQueryParameter['lastKey'] = lastKey;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new game.
         * @param {GamesPostRequest} gamesPostRequest A JSON object containing the poker game information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesPost: function (gamesPostRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([gamesPostRequest_1], args_1, true), void 0, function (gamesPostRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gamesPostRequest' is not null or undefined
                            assertParamExists('gamesPost', 'gamesPostRequest', gamesPostRequest);
                            localVarPath = "/games";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication poker-wise-default-authorizer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Cookie", configuration)];
                        case 1:
                            // authentication poker-wise-default-authorizer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(gamesPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of all games of tenants with pagination.
         * @param {string} tenant The tenant identifier.
         * @param {number} [limit] The maximum number of games to return.
         * @param {string} [lastKey] The pagination token to continue fetching results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantGet: function (tenant_1, limit_1, lastKey_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tenant_1, limit_1, lastKey_1], args_1, true), void 0, function (tenant, limit, lastKey, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenant' is not null or undefined
                            assertParamExists('gamesTenantTenantGet', 'tenant', tenant);
                            localVarPath = "/games/tenant/{tenant}"
                                .replace("{".concat("tenant", "}"), encodeURIComponent(String(tenant)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication poker-wise-default-authorizer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Cookie", configuration)];
                        case 1:
                            // authentication poker-wise-default-authorizer required
                            _a.sent();
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (lastKey !== undefined) {
                                localVarQueryParameter['lastKey'] = lastKey;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a game.
         * @param {string} tenant The tenant identifier.
         * @param {string} id The unique identifier of the game.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantIdIdDelete: function (tenant_1, id_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tenant_1, id_1], args_1, true), void 0, function (tenant, id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenant' is not null or undefined
                            assertParamExists('gamesTenantTenantIdIdDelete', 'tenant', tenant);
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('gamesTenantTenantIdIdDelete', 'id', id);
                            localVarPath = "/games/tenant/{tenant}/id/{id}"
                                .replace("{".concat("tenant", "}"), encodeURIComponent(String(tenant)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication poker-wise-default-authorizer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Cookie", configuration)];
                        case 1:
                            // authentication poker-wise-default-authorizer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get details of a specific game by ID.
         * @param {string} tenant The tenant identifier.
         * @param {string} id The unique identifier of the game.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantIdIdGet: function (tenant_1, id_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tenant_1, id_1], args_1, true), void 0, function (tenant, id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenant' is not null or undefined
                            assertParamExists('gamesTenantTenantIdIdGet', 'tenant', tenant);
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('gamesTenantTenantIdIdGet', 'id', id);
                            localVarPath = "/games/tenant/{tenant}/id/{id}"
                                .replace("{".concat("tenant", "}"), encodeURIComponent(String(tenant)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication poker-wise-default-authorizer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Cookie", configuration)];
                        case 1:
                            // authentication poker-wise-default-authorizer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an existing game.
         * @param {string} tenant The tenant identifier.
         * @param {string} id The unique identifier of the game.
         * @param {GamesTenantTenantIdIdPutRequest} gamesTenantTenantIdIdPutRequest A JSON object for updating the poker game information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantIdIdPut: function (tenant_1, id_1, gamesTenantTenantIdIdPutRequest_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tenant_1, id_1, gamesTenantTenantIdIdPutRequest_1], args_1, true), void 0, function (tenant, id, gamesTenantTenantIdIdPutRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenant' is not null or undefined
                            assertParamExists('gamesTenantTenantIdIdPut', 'tenant', tenant);
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('gamesTenantTenantIdIdPut', 'id', id);
                            // verify required parameter 'gamesTenantTenantIdIdPutRequest' is not null or undefined
                            assertParamExists('gamesTenantTenantIdIdPut', 'gamesTenantTenantIdIdPutRequest', gamesTenantTenantIdIdPutRequest);
                            localVarPath = "/games/tenant/{tenant}/id/{id}"
                                .replace("{".concat("tenant", "}"), encodeURIComponent(String(tenant)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication poker-wise-default-authorizer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Cookie", configuration)];
                        case 1:
                            // authentication poker-wise-default-authorizer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(gamesTenantTenantIdIdPutRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get games by lobby ID.
         * @param {string} tenant The tenant identifier.
         * @param {string} lobbyId The unique identifier of the lobby.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantLobbyLobbyIdGet: function (tenant_1, lobbyId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tenant_1, lobbyId_1], args_1, true), void 0, function (tenant, lobbyId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenant' is not null or undefined
                            assertParamExists('gamesTenantTenantLobbyLobbyIdGet', 'tenant', tenant);
                            // verify required parameter 'lobbyId' is not null or undefined
                            assertParamExists('gamesTenantTenantLobbyLobbyIdGet', 'lobbyId', lobbyId);
                            localVarPath = "/games/tenant/{tenant}/lobby/{lobbyId}"
                                .replace("{".concat("tenant", "}"), encodeURIComponent(String(tenant)))
                                .replace("{".concat("lobbyId", "}"), encodeURIComponent(String(lobbyId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication poker-wise-default-authorizer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Cookie", configuration)];
                        case 1:
                            // authentication poker-wise-default-authorizer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get details of a game by name.
         * @param {string} tenant The tenant identifier.
         * @param {string} name The name of the game.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantNameNameGet: function (tenant_1, name_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tenant_1, name_1], args_1, true), void 0, function (tenant, name, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenant' is not null or undefined
                            assertParamExists('gamesTenantTenantNameNameGet', 'tenant', tenant);
                            // verify required parameter 'name' is not null or undefined
                            assertParamExists('gamesTenantTenantNameNameGet', 'name', name);
                            localVarPath = "/games/tenant/{tenant}/name/{name}"
                                .replace("{".concat("tenant", "}"), encodeURIComponent(String(tenant)))
                                .replace("{".concat("name", "}"), encodeURIComponent(String(name)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication poker-wise-default-authorizer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Cookie", configuration)];
                        case 1:
                            // authentication poker-wise-default-authorizer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get games by table ID.
         * @param {string} tenant The tenant identifier.
         * @param {string} tableId The unique identifier of the tableId.
         * @param {number} [limit] The maximum number of games to return.
         * @param {string} [lastEvaluatedKey] Bir sonraki sayfayı getirmek için kullanılan token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantTableTableIdGet: function (tenant_1, tableId_1, limit_1, lastEvaluatedKey_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tenant_1, tableId_1, limit_1, lastEvaluatedKey_1], args_1, true), void 0, function (tenant, tableId, limit, lastEvaluatedKey, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenant' is not null or undefined
                            assertParamExists('gamesTenantTenantTableTableIdGet', 'tenant', tenant);
                            // verify required parameter 'tableId' is not null or undefined
                            assertParamExists('gamesTenantTenantTableTableIdGet', 'tableId', tableId);
                            localVarPath = "/games/tenant/{tenant}/table/{tableId}"
                                .replace("{".concat("tenant", "}"), encodeURIComponent(String(tenant)))
                                .replace("{".concat("tableId", "}"), encodeURIComponent(String(tableId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication poker-wise-default-authorizer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Cookie", configuration)];
                        case 1:
                            // authentication poker-wise-default-authorizer required
                            _a.sent();
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (lastEvaluatedKey !== undefined) {
                                localVarQueryParameter['lastEvaluatedKey'] = lastEvaluatedKey;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get games by type.
         * @param {string} tenant The tenant identifier.
         * @param {GamesTenantTenantTypeTypeGetTypeEnum} type The type of the game.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantTypeTypeGet: function (tenant_1, type_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tenant_1, type_1], args_1, true), void 0, function (tenant, type, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenant' is not null or undefined
                            assertParamExists('gamesTenantTenantTypeTypeGet', 'tenant', tenant);
                            // verify required parameter 'type' is not null or undefined
                            assertParamExists('gamesTenantTenantTypeTypeGet', 'type', type);
                            localVarPath = "/games/tenant/{tenant}/type/{type}"
                                .replace("{".concat("tenant", "}"), encodeURIComponent(String(tenant)))
                                .replace("{".concat("type", "}"), encodeURIComponent(String(type)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication poker-wise-default-authorizer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Cookie", configuration)];
                        case 1:
                            // authentication poker-wise-default-authorizer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * GameControllerApi - functional programming interface
 * @export
 */
export var GameControllerApiFp = function (configuration) {
    var localVarAxiosParamCreator = GameControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get a list of all games with pagination.
         * @param {number} [limit] The maximum number of games to return.
         * @param {string} [lastKey] The pagination token to continue fetching results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesGet: function (limit, lastKey, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.gamesGet(limit, lastKey, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = operationServerMap['GameControllerApi.gamesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new game.
         * @param {GamesPostRequest} gamesPostRequest A JSON object containing the poker game information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesPost: function (gamesPostRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.gamesPost(gamesPostRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = operationServerMap['GameControllerApi.gamesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of all games of tenants with pagination.
         * @param {string} tenant The tenant identifier.
         * @param {number} [limit] The maximum number of games to return.
         * @param {string} [lastKey] The pagination token to continue fetching results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantGet: function (tenant, limit, lastKey, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.gamesTenantTenantGet(tenant, limit, lastKey, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = operationServerMap['GameControllerApi.gamesTenantTenantGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a game.
         * @param {string} tenant The tenant identifier.
         * @param {string} id The unique identifier of the game.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantIdIdDelete: function (tenant, id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.gamesTenantTenantIdIdDelete(tenant, id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = operationServerMap['GameControllerApi.gamesTenantTenantIdIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get details of a specific game by ID.
         * @param {string} tenant The tenant identifier.
         * @param {string} id The unique identifier of the game.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantIdIdGet: function (tenant, id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.gamesTenantTenantIdIdGet(tenant, id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = operationServerMap['GameControllerApi.gamesTenantTenantIdIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an existing game.
         * @param {string} tenant The tenant identifier.
         * @param {string} id The unique identifier of the game.
         * @param {GamesTenantTenantIdIdPutRequest} gamesTenantTenantIdIdPutRequest A JSON object for updating the poker game information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantIdIdPut: function (tenant, id, gamesTenantTenantIdIdPutRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.gamesTenantTenantIdIdPut(tenant, id, gamesTenantTenantIdIdPutRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = operationServerMap['GameControllerApi.gamesTenantTenantIdIdPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get games by lobby ID.
         * @param {string} tenant The tenant identifier.
         * @param {string} lobbyId The unique identifier of the lobby.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantLobbyLobbyIdGet: function (tenant, lobbyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.gamesTenantTenantLobbyLobbyIdGet(tenant, lobbyId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = operationServerMap['GameControllerApi.gamesTenantTenantLobbyLobbyIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get details of a game by name.
         * @param {string} tenant The tenant identifier.
         * @param {string} name The name of the game.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantNameNameGet: function (tenant, name, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.gamesTenantTenantNameNameGet(tenant, name, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = operationServerMap['GameControllerApi.gamesTenantTenantNameNameGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get games by table ID.
         * @param {string} tenant The tenant identifier.
         * @param {string} tableId The unique identifier of the tableId.
         * @param {number} [limit] The maximum number of games to return.
         * @param {string} [lastEvaluatedKey] Bir sonraki sayfayı getirmek için kullanılan token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantTableTableIdGet: function (tenant, tableId, limit, lastEvaluatedKey, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.gamesTenantTenantTableTableIdGet(tenant, tableId, limit, lastEvaluatedKey, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = operationServerMap['GameControllerApi.gamesTenantTenantTableTableIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get games by type.
         * @param {string} tenant The tenant identifier.
         * @param {GamesTenantTenantTypeTypeGetTypeEnum} type The type of the game.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantTypeTypeGet: function (tenant, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.gamesTenantTenantTypeTypeGet(tenant, type, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = operationServerMap['GameControllerApi.gamesTenantTenantTypeTypeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
/**
 * GameControllerApi - factory interface
 * @export
 */
export var GameControllerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = GameControllerApiFp(configuration);
    return {
        /**
         *
         * @summary Get a list of all games with pagination.
         * @param {GameControllerApiGamesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesGet: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.gamesGet(requestParameters.limit, requestParameters.lastKey, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new game.
         * @param {GameControllerApiGamesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesPost: function (requestParameters, options) {
            return localVarFp.gamesPost(requestParameters.gamesPostRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list of all games of tenants with pagination.
         * @param {GameControllerApiGamesTenantTenantGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantGet: function (requestParameters, options) {
            return localVarFp.gamesTenantTenantGet(requestParameters.tenant, requestParameters.limit, requestParameters.lastKey, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a game.
         * @param {GameControllerApiGamesTenantTenantIdIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantIdIdDelete: function (requestParameters, options) {
            return localVarFp.gamesTenantTenantIdIdDelete(requestParameters.tenant, requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get details of a specific game by ID.
         * @param {GameControllerApiGamesTenantTenantIdIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantIdIdGet: function (requestParameters, options) {
            return localVarFp.gamesTenantTenantIdIdGet(requestParameters.tenant, requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update an existing game.
         * @param {GameControllerApiGamesTenantTenantIdIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantIdIdPut: function (requestParameters, options) {
            return localVarFp.gamesTenantTenantIdIdPut(requestParameters.tenant, requestParameters.id, requestParameters.gamesTenantTenantIdIdPutRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get games by lobby ID.
         * @param {GameControllerApiGamesTenantTenantLobbyLobbyIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantLobbyLobbyIdGet: function (requestParameters, options) {
            return localVarFp.gamesTenantTenantLobbyLobbyIdGet(requestParameters.tenant, requestParameters.lobbyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get details of a game by name.
         * @param {GameControllerApiGamesTenantTenantNameNameGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantNameNameGet: function (requestParameters, options) {
            return localVarFp.gamesTenantTenantNameNameGet(requestParameters.tenant, requestParameters.name, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get games by table ID.
         * @param {GameControllerApiGamesTenantTenantTableTableIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantTableTableIdGet: function (requestParameters, options) {
            return localVarFp.gamesTenantTenantTableTableIdGet(requestParameters.tenant, requestParameters.tableId, requestParameters.limit, requestParameters.lastEvaluatedKey, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get games by type.
         * @param {GameControllerApiGamesTenantTenantTypeTypeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesTenantTenantTypeTypeGet: function (requestParameters, options) {
            return localVarFp.gamesTenantTenantTypeTypeGet(requestParameters.tenant, requestParameters.type, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * GameControllerApi - object-oriented interface
 * @export
 * @class GameControllerApi
 * @extends {BaseAPI}
 */
var GameControllerApi = /** @class */ (function (_super) {
    __extends(GameControllerApi, _super);
    function GameControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get a list of all games with pagination.
     * @param {GameControllerApiGamesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameControllerApi
     */
    GameControllerApi.prototype.gamesGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return GameControllerApiFp(this.configuration).gamesGet(requestParameters.limit, requestParameters.lastKey, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new game.
     * @param {GameControllerApiGamesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameControllerApi
     */
    GameControllerApi.prototype.gamesPost = function (requestParameters, options) {
        var _this = this;
        return GameControllerApiFp(this.configuration).gamesPost(requestParameters.gamesPostRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list of all games of tenants with pagination.
     * @param {GameControllerApiGamesTenantTenantGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameControllerApi
     */
    GameControllerApi.prototype.gamesTenantTenantGet = function (requestParameters, options) {
        var _this = this;
        return GameControllerApiFp(this.configuration).gamesTenantTenantGet(requestParameters.tenant, requestParameters.limit, requestParameters.lastKey, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a game.
     * @param {GameControllerApiGamesTenantTenantIdIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameControllerApi
     */
    GameControllerApi.prototype.gamesTenantTenantIdIdDelete = function (requestParameters, options) {
        var _this = this;
        return GameControllerApiFp(this.configuration).gamesTenantTenantIdIdDelete(requestParameters.tenant, requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get details of a specific game by ID.
     * @param {GameControllerApiGamesTenantTenantIdIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameControllerApi
     */
    GameControllerApi.prototype.gamesTenantTenantIdIdGet = function (requestParameters, options) {
        var _this = this;
        return GameControllerApiFp(this.configuration).gamesTenantTenantIdIdGet(requestParameters.tenant, requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update an existing game.
     * @param {GameControllerApiGamesTenantTenantIdIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameControllerApi
     */
    GameControllerApi.prototype.gamesTenantTenantIdIdPut = function (requestParameters, options) {
        var _this = this;
        return GameControllerApiFp(this.configuration).gamesTenantTenantIdIdPut(requestParameters.tenant, requestParameters.id, requestParameters.gamesTenantTenantIdIdPutRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get games by lobby ID.
     * @param {GameControllerApiGamesTenantTenantLobbyLobbyIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameControllerApi
     */
    GameControllerApi.prototype.gamesTenantTenantLobbyLobbyIdGet = function (requestParameters, options) {
        var _this = this;
        return GameControllerApiFp(this.configuration).gamesTenantTenantLobbyLobbyIdGet(requestParameters.tenant, requestParameters.lobbyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get details of a game by name.
     * @param {GameControllerApiGamesTenantTenantNameNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameControllerApi
     */
    GameControllerApi.prototype.gamesTenantTenantNameNameGet = function (requestParameters, options) {
        var _this = this;
        return GameControllerApiFp(this.configuration).gamesTenantTenantNameNameGet(requestParameters.tenant, requestParameters.name, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get games by table ID.
     * @param {GameControllerApiGamesTenantTenantTableTableIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameControllerApi
     */
    GameControllerApi.prototype.gamesTenantTenantTableTableIdGet = function (requestParameters, options) {
        var _this = this;
        return GameControllerApiFp(this.configuration).gamesTenantTenantTableTableIdGet(requestParameters.tenant, requestParameters.tableId, requestParameters.limit, requestParameters.lastEvaluatedKey, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get games by type.
     * @param {GameControllerApiGamesTenantTenantTypeTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameControllerApi
     */
    GameControllerApi.prototype.gamesTenantTenantTypeTypeGet = function (requestParameters, options) {
        var _this = this;
        return GameControllerApiFp(this.configuration).gamesTenantTenantTypeTypeGet(requestParameters.tenant, requestParameters.type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return GameControllerApi;
}(BaseAPI));
export { GameControllerApi };
/**
 * @export
 */
export var GamesTenantTenantTypeTypeGetTypeEnum = {
    Texasholdem: 'texasholdem',
    Turkishpoker: 'turkishpoker',
    Omaha4: 'omaha4',
    Omaha5: 'omaha5'
};
